export default "__VITE_ASSET__mX_GwZYS__"